import React, {ReactNode} from 'react';

export default class PokerDealer extends React.Component {
    render(): ReactNode {
        return <span className="poker-dealer">
            <b className="icon-d">D</b>
        </span>;
    }
}
